import { render, staticRenderFns } from "./FAQs.vue?vue&type=template&id=21479e80&scoped=true"
import script from "./FAQs.vue?vue&type=script&lang=js"
export * from "./FAQs.vue?vue&type=script&lang=js"
import style0 from "./FAQs.vue?vue&type=style&index=0&id=21479e80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21479e80",
  null
  
)

export default component.exports